/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';

// Demo icons
import { faEllipsisHIcon } from 'IconLibrary/fontawesome/regular/ellipsis-h';
import { faExclamationTriangleIcon } from 'IconLibrary/fontawesome/regular/exclamation-triangle';
import { faDownloadIcon } from 'IconLibrary/fontawesome/regular/download';
import { faLinkIcon } from 'IconLibrary/fontawesome/regular/link';
import { faPlusIcon } from 'IconLibrary/fontawesome/regular/plus';
import { faRedoIcon } from 'IconLibrary/fontawesome/regular/redo';
import { faRedoAltIcon } from 'IconLibrary/fontawesome/regular/redo-alt';

import { TranslocoModule } from '@jsverse/transloco';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { PopoverModule } from 'primeng/popover';
import { MenuItemActionComponent } from './menu-item-action/menu-item-action.component';
import { MenuListComponent } from './menu-list/menu-list.component';
import { MenuListPanelComponent } from './menu-list-panel/menu-list-panel.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { RadioListComponent } from './radio-list/radio-list.component';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { BulbMenusTranslationProvider } from './translation-provider';
import { MenubarComponent } from './menubar/menubar.component';
import { MenubarItemComponent } from './menubar-item/menubar-item.component';
import { MenubarItemActionComponent } from './menubar-item-action/menubar-item-action.component';
import { AeroModule } from '../../aero/aero.module';

@NgModule({
  declarations: [
    MenuItemActionComponent,
    MenuListComponent,
    MenuListComponent,
    MenuListPanelComponent,
    MenuItemComponent,
    MenubarComponent,
    MenubarItemComponent,
    MenubarItemActionComponent,
    RadioListComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,

    InputSwitchModule,
    PopoverModule,
    SVGIconModule,

    // Other Modules
    TooltipModule,
    TranslocoModule,
    SvgIconComponent,
    AeroModule,
  ],
  exports: [
    MenuItemActionComponent,
    MenuListPanelComponent,
    MenuListComponent,
    MenubarComponent,
    RadioListComponent,
  ],
  providers: [
    BulbMenusTranslationProvider,
    provideSvgIcons([
      faEllipsisHIcon,
      // Demo icons
      faExclamationTriangleIcon,
      faDownloadIcon,
      faLinkIcon,
      faPlusIcon,
      faRedoIcon,
      faRedoAltIcon,
    ]),
  ],
})
export class MenusModule { }
